import { render, staticRenderFns } from "./real-case.vue?vue&type=template&id=128b4056&scoped=true"
import script from "./real-case.vue?vue&type=script&lang=js"
export * from "./real-case.vue?vue&type=script&lang=js"
import style0 from "./real-case.vue?vue&type=style&index=0&id=128b4056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b4056",
  null
  
)

export default component.exports